export const SentryScreenDisplay = (_props: { ready: boolean }) => null;
